import createColor from 'color';
import { StyleSheet } from 'aphrodite';
import { media, mixins } from '@blend/consumer-components';

import * as deploymentConfig from 'login-utils/deploymentConfig';
import { loginBackgroundDynamicColor } from 'login-stylesheets/deploymentColors';

const orgColors = deploymentConfig.getOrganizationColors();

export const desktopWidth = '30%';
export const mobileWidth = '27%';

const action = orgColors.action;
const actionColorLightness = createColor(action).lightness();

const actionDark = mixins.darken(action, 0.25);
const actionLight = mixins.lighten(action, 0.25);
const actionGrey = mixins.lighten(mixins.desaturate(action, 0.6), 0.3);
const actionDarkGrey = mixins.lighten(mixins.desaturate(action, 0.3), 0.2);

const svgWidthStyle = {
  // We specify both minWidth and width so that this component works with flex containers and in IE
  // (min-width will make it so that it's not made smaller by flex-grow in flex settings; width will make it
  // so that this component has the right width in IE, otherwise it stretches out)
  minWidth: desktopWidth,
  width: desktopWidth,
  [media.mobileMedium]: {
    minWidth: mobileWidth,
    width: mobileWidth,
    paddingLeft: 10,
    paddingRight: 10,
  },
};

const styles = StyleSheet.create({
  action: {
    fill: action,
  },
  actionAccent: {
    fill: actionColorLightness > 30 ? actionDark : actionLight,
  },
  grey: {
    fill: actionColorLightness > 50 ? actionDarkGrey : actionGrey,
  },
  white: {
    fill: '#FFFFFF',
  },
  login: {
    fill: loginBackgroundDynamicColor,
  },
  width: svgWidthStyle,
  box: {
    ...svgWidthStyle,
    height: 100,
  },
});

export default styles;
